import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { IPaginate } from '@projects/shared/src/app/modules/pagination/paginate.pipe';
import { SummariesService } from '../summaries.service';
import { momentCustomInstance as moment, CheckPermission, sortList } from '@projects/shared/src/app/utils/helper';
import { ExportData } from '@projects/shared/src/app/modules/predictive-search-filter/predictive-search-filter.component';
import { naturalSensitiveSort } from '@projects/shared/src/app/utils/sort';
import { AuthenticationService } from '@app/core';
import { DateOptions } from '@projects/shared/src/app/modules/cx-datagrid/cx-datagrid-config';
import { GridMode } from '@projects/shared/src/app/modules/cx-datagrid/types/gridmode';
import { ActivatedRoute } from '@angular/router';
import { AppConfigurationService } from '@projects/shared/src/app/services/app.configuration.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { ExportService } from '@projects/shared/src/app/services/export.service';
import { formatDate, convertToSeconds } from '@projects/shared/src/app/utils';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';
import { CallBackService } from '@projects/shared/src/app/services/call-back.service';
import { TelephonyStateService } from '@projects/shared/src/app/providers/telephony/telephony.state.service';
import { TelephonyProvider } from '@projects/shared/src/app/providers/telephony/telephony.provider';
import { Constants, EVENT_NAMES, EVENT_TYPES } from '@app/constants';
import { CallType } from '../../../call/interfaces/CallType/CallType';
import { AgentStatusService } from '@projects/shared/src/app/services/agentstatus.service';
import { NavService } from '@projects/shared/src/app/services/nav.service';
import { HttpClient } from '@angular/common/http';
const ColumnKeys = {
  MyCallsReport: 'my_calls_report',
  CallLogReport: 'agent_calllogs_report',
  MySalesReport: 'my_sales_report',
  MeetingSchedularReport: 'meeting_schedular_report',
  CallBackReport: 'callback_report',
  AssignedLeadsReport: 'assgined_leads_report',
};

const ReportType: any = {
  callback: 'Callback',
  leads: 'AssignLeads',
  'lead-schedular': 'MeetingSchedular',
  'my-calls': 'MyCalls',
  'my-sales': 'MySales',
  'callLog': 'CallLogs',
};

@Component({
  selector: 'app-agent-summaries-repreportsort',
  templateUrl: './agent-summaries-reports.component.html',
  styleUrls: ['./agent-summaries-reports.component.scss'],
})
export class AgentSummariesReportComponent implements OnInit, OnDestroy {
  @Output() applyDate = new EventEmitter();
  checkPermission = CheckPermission;
  views: any[] = [{ name: 'All', id: '', showPined: false, pined: true }];
  module = 'summaries-';
  fieldmodule = 'summaries';
  GridMode = GridMode;
  gridMode: GridMode = GridMode.Grid;
  totalCount = 0;
  convertSecondsToTime = formatDate;
  public pagingConfig: IPaginate = {
    id: 'contact-list',
    itemsPerPage: 15,
    currentPage: 1,
    totalItems: this.totalCount,
  };
  searchQuery = '';
  datagridPlaceholder = '';
  columns: any[] = [];
  agentList = [];
  records: any[] = [];
  initialTotalCallListRows = 0;
  toDate: string = moment().utc().endOf('day').toISOString();
  fromDate: string = moment().utc().startOf('week').toISOString();
  selectedAgentId: string = '';
  localSearchValue = '';
  pageNumberBeforeLocalSearch = 1;
  export: ExportData = { Data: this.records, FileName: 'call_list_report', Columns: [] };
  filter: any = { fields: '', fieldValues: '', criteria: '', limit: 15, skip: 0 };
  adv_filters: any[] = [];
  call_sid: any = '';
  search_meta: any = [];
  subscriptions: Array<Subscription> = new Array<Subscription>();
  sortColumn: any = { searchField: 'CreatedOn', order: -1 };
  title = '';
  reportType = '';
  isShowExport: boolean = true;
  show = true;
  callEnabled: boolean = true;
  callIndex = -1;
  dropdownStates: { [key: number]: boolean } = {};
  moreOptions = {
    label: '',
    directComponentRender: false,
    showFrozenOption: true,
    saveConfig: true,
  };
  configColumns: any[] = [];
  constructor(
    public appConfig: AppConfigurationService,
    public service: SummariesService,
    public authService: AuthenticationService,
    public exportService: ExportService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private toastService: ToastService,
    private callbackService: CallBackService,
    private telephonyState: TelephonyStateService,
    private telephony: TelephonyProvider,
    private statusService: AgentStatusService,
    private navService: NavService,
    private http: HttpClient
  ) {
    this.route.data.subscribe((x) => {
      this.adv_filters = [];
      this.search_meta = [];
      this.views = [];
      this.columns = [];
      this.datagridPlaceholder = '';
      this.fieldmodule = 'agent-summaries';
      this.filter = { fields: '', fieldValues: '', criteria: '', limit: 15, skip: 0 };
      this.fromDate = moment().utc().startOf('week').toISOString();
      this.totalCount = 0;
      this.pagingConfig = {
        id: 'contact-list',
        itemsPerPage: 15,
        currentPage: 1,
        totalItems: this.totalCount,
      };

      this.show = false;
      // if (route.snapshot.routeConfig?.path === 'agent-wise-summary') {
      //   this.fieldmodule = 'agents-summary'
      // } else if (route.snapshot.routeConfig?.path === 'daily-summary') {
      //   this.fieldmodule = 'daily-summary'
      // } else if (route.snapshot.routeConfig?.path === 'agents-acitvity') {
      //   this.fieldmodule = 'agents'
      // }

      this.module = 'summaries-' + (route.snapshot.routeConfig?.path || '');
      this.title = x.title;
      this.init();
      // console.log(new Date().toLocaleString() + '  ➤  this.title ==> ', this.title);
    });
  }
  ngOnDestroy(): void { }

  mapDateColumn() {
    this.columns = this.columns.filter(Boolean).map((x) => {
      if (x.key === 'start_end') {
        x.options = DateOptions;
      }
      return x;
    });
    this.datagridPlaceholder =
      'Search by ' +
      this.columns
        .filter((x) => x.searchable)
        .map((x) => x.name)
        .join(', ');
    this.configColumns = JSON.parse(JSON.stringify(this.columns));
  }

  async onDialCall(ctx: any, index: any) {
    if (!this.callEnabled && this.callIndex > 0) {
      this.toastService.warning('Please wait, dialing in progress');
      return;
    }
    if (this.telephonyState.onCall) {
      this.toastService.warning('Call is in progress. Please dispose current call');
      return;
    }
    if (this.isIbexDialer()) {
      const allowedStatuses = ['Callback', 'ManualCall'];
      if (!allowedStatuses.includes(this.statusService.currentStatus.FriendlyName)) {
        this.toastService.info('Manual Call or Callback status is required to make a call');
        return;
      }
    }
    this.callIndex = index;
    //let row: any = this.records[index];
    this.telephonyState.lastCallDialedFromUrl = { url: '/agent/summaries/leads', queryParam: { assignedLeads: true } };
    this.telephony.voice.events.next({
      type: EVENT_TYPES.OutboundDialer,
      name: EVENT_NAMES.Callback,
      data: {
        lead_id: ctx.row._id,
        phone_number: ctx.row.phone_number,
        direction: CallType.Outbound,
        type: 'assigned-lead',
        data: ctx.row.customer_data.payload,
        lead_source: ctx.row.lead_source,
        countryCode: ctx.row.country_code,
        pass_lead: true,
        dial_count: ctx.row.dial_count,
      },
    });
  }

  async onCallbackDial(ctx: any, index: any, type: string) {
    //* FOR PK ONLY
    //* TRACK CallBack Count
    let res = await this.authService.fetchTodayCallbacksCount();
    const count = res?.length > 0 ? res[0].count : 0;
    const limit = this.appConfig.getByIdentifier('ScriptSkillCodesAndTFNS').Fields['CALL_BACK_CALLS_LIMIT'] ?? 15;

    let isLimitReached: boolean = count === limit;
    if (isLimitReached) {
      this.toastService.warning('Maximum number of Callback reached');
      return;
    }
    //* TRACK OutboundCallResitriction for specific time
    if (this.telephonyState.isOutboundCallRestriction(ctx.row.TFNCampaignCode)) {
      return;
    }

    this.hideAllDropdowns();
    if (!this.callEnabled && this.callIndex > 0) {
      this.toastService.warning('Please wait, dialing in progress');
      return;
    }
    if (this.telephonyState.onCall) {
      this.toastService.warning('Call is in progress. Please dispose current call');
      return;
    }
    if (this.isIbexDialer()) {
      const allowedStatuses = ['Callback', 'ManualCall'];
      if (!allowedStatuses.includes(this.statusService.currentStatus.FriendlyName)) {
        this.toastService.info('Manual Call or Callback status is required to make a call');
        return;
      }
    }
    this.callIndex = index;
    //let row: any = this.records[index];
    this.telephonyState.lastCallDialedFromUrl = { url: '/agent/summaries/callback', queryParam: {} };
    if (ctx.row.LeadId) {
      const lead: any = await this.callbackService.getLead(
        ctx.row.CampaignId,
        ctx.row.ConfirmBTN,
        '',
        ctx.row.LeadId,
        1
      );
      if (!lead.Id) {
        this.toastService.info('Assign lead to this call not found');
        return;
      }
      if (lead.CurrentStatus == 'InProgress') {
        this.toastService.warning('Call is already scheduled from preview dialer. Cannot callback now');
        return;
      }
      if (lead.LifeCycleStage == 'Close') {
        this.toastService.warning('Lead is in finalized state. Call cannot be made');
        return;
      }
      this.telephony.voice.events.next({
        type: EVENT_TYPES.OutboundDialer,
        name: EVENT_NAMES.Callback,
        data: {
          lead_id: lead.Id,
          phone_number: lead.Data.PhoneNumber,
          direction: CallType.Outbound,
          type: 'callback',
          data: lead.Data.Payload,
          lead_source: lead.LeadSource,
          countryCode: lead.CountryCode,
          pass_lead: false,
          dial_count: lead.DialCount,
          campaign_code: ctx.row.CampaignCode,
          primary_call_sid: ctx.row.CallSid,
        },
      });
    } else {
      // console.log(new Date().toLocaleString() + '  ➤  ctx.row ==> ', ctx.row);
      let number = type == 'primary' ? ctx.row.ConfirmBTN : ctx.row.CallbackNumber;
      this.telephony.voice.makeCall(
        null,
        number,
        'callback',
        {},
        ctx.row.TFN,
        {
          Id: ctx.row.CampaignId,
          Code: ctx.row.CampaignCode,
          Name: ctx.row.Campaign,
          tfnCampaignId: ctx.row.TFNCampaignId,
          tfnCampaignCode: ctx.row.TFNCampaignCode,
          tfnCampaignName: ctx.row.TFNCampaign,
          primary_call_sid: ctx.row.CallSid,
        },
        '',
        ctx.row.CallSid,
        'callback'
      );
    }
  }

  
  showDialOption() { }
  reset() {
    this.records = [];
    this.pagingConfig.totalItems = 0;
    this.pagingConfig.itemsPerPage = 15;
    this.pagingConfig.currentPage = 1;
  }

  init() {
    this.reset();
    const path: string = this.route.snapshot.routeConfig?.path || '';
    this.reportType = ReportType[path] || 'None';
    if (path === 'my-calls') {
      this.isShowExport = true;
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.MyCallsReport).Fields.columns;
    } else if (path === 'my-sales') {
      this.isShowExport = true;
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.MySalesReport).Fields.columns;
    } else if (path == 'lead-schedular') {
      this.isShowExport = false;
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.MeetingSchedularReport).Fields.columns;
    } else if (path == 'leads') {
      this.isShowExport = false;
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.AssignedLeadsReport).Fields.columns;
    } else if (path == 'callback') {
      this.isShowExport = false;
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.CallBackReport).Fields.columns;
      this.fromDate = moment().startOf('day').toISOString();
      this.toDate = moment().endOf('day').toISOString();
    } else if (path == 'callLog') {
      this.isShowExport = false;
      this.columns = this.appConfig.getByIdentifier(ColumnKeys.CallLogReport).Fields.columns;
    }
    this.mapDateColumn();
    this.getGridSetting();
    setTimeout(() => {
      this.show = true;
      this.cd.detectChanges();
    }, 0);
    this.getList();
  }

  ngOnInit(): void {
    this.init();
  }

  onApplyDate(values: any) {
    this.fromDate = moment(values[0]).startOf('day').toISOString();
    this.toDate = moment(values[1]).endOf('day').toISOString();
    //reset pagination
    this.pagingConfig.currentPage = 1;
    this.filter.skip = 0;
    //fetch data
    this.getList();
  }

  exportData(event: any) {
    this.getListSubscription().subscribe((data: any) => {
      this.export.Data = data.Results || [];
      this.export.Data = this.formatData(this.export.Data);
      this.export.Columns = this.columns.filter((d: any) => d.viewable !== false && d.name).map((d: any) => d.key);
      if (this.export.Columns?.length)
        event.exportCallback(this.export.Data, this.export.FileName, this.export.Columns, this.columns);
    });
  }

  exportAllData(event: any) {
    this.getListSubscription({ IsExportAll: true }).subscribe((data: any) => {
      this.export.Data = data.Results || [];
      this.export.Data = this.formatData(this.export.Data);
      this.export.Columns = this.columns.filter((d: any) => d.viewable !== false && d.name).map((d: any) => d.key);
      if (this.export.Columns?.length)
        event.exportCallback(this.export.Data, this.export.FileName, this.export.Columns, this.columns);
    });
  }

  formatData(data: any) {
    let _data = data.map((row: any) => {
      return Object.entries(row).reduce((dataObj: any, [prop, value]) => {
        const col = this.columns.find((col) => col.key === prop);
        if (col?.format === 'date') dataObj[prop] = moment(value).format('DD MMM YYYY');
        else if (col?.format === 'time') dataObj[prop] = formatDate(Number(value));
        else dataObj[prop] = value;
        return dataObj;
      }, {});
    });

    return _data.map((row: any) =>
      this.columns.reduce((rowObject: any, column: any) => {
        if (!row.hasOwnProperty(column.key) && column.viewable && column.name) row[column.key] = 'NA';
        return row;
      }, {})
    );
  }

  onExport($event: any) {
    if ($event.limit === 'all-data') {
      $event.exportCallback = this.exportService.exportToCsvV2.bind(this.exportService);
      this.exportAllData($event);
    } else {
      $event.exportCallback = this.exportService.exportToCsvV2.bind(this.exportService);
      this.exportData($event);
    }
  }

  getListSubscription(additionalOptions = {}) {
    const payload = {
      Type: this.reportType,
      Sightline: {
        StartDate: this.fromDate,
        EndDate: this.toDate,
        Fields: this.filter.fields,
        FieldValues: this.filter.fieldValues,
        Criteria: this.filter.criteria,
        Limit: this.filter.limit,
        Skip: this.filter.skip,
        AdvFilters: this.adv_filters,
        SearchMeta: this.search_meta,
        SortMeta: {
          order: this.sortColumn.order == 1 ? this.sortColumn.order : -1,
          field: this.sortColumn.searchField,
        },
        ...additionalOptions,
      },
    };
    console.log(payload)
    return this.service.getAgentSummaryReportByType(payload);
  }

  getList = (): void => {
    this.getListSubscription().subscribe((data: any) => {
      let rows = data.Results || [];
      rows.forEach((r: any) => {
        r.show = false;
      });
      this.records = rows;
      this.totalCount = data.TotalCount;
      this.pagingConfig.totalItems = this.initialTotalCallListRows = data.TotalCount;
    });
  };

  onSort(e: any) {
    this.totalCount = 0;
    this.pagingConfig = {
      id: 'contact-list',
      itemsPerPage: this.pagingConfig.itemsPerPage,
      currentPage: 1,
      totalItems: this.totalCount,
    };
    this.filter = { fields: '', fieldValues: '', criteria: '', limit: this.pagingConfig.itemsPerPage, skip: 0 };
    const { key, name, display, order } = e;
    this.columns.forEach((col: any) => {
      if (col.key !== key) {
        col.order = false;
      }
    });
    this.sortColumn = e;
    this.getList();
  }

  onPageChange(page: number) {
    this.pagingConfig.currentPage = this.pageNumberBeforeLocalSearch = page;
    this.filter = {
      ...this.filter,
      limit: this.pagingConfig.itemsPerPage,
      skip: (this.pagingConfig.currentPage - 1) * this.pagingConfig.itemsPerPage,
    };
    if (!this.localSearchValue) {
      this.getList();
    } else {
      this.pagingConfig.totalItems = this.records.length;
    }
  }

  onPageSizeChange(pageSize: any) {
    this.pagingConfig.itemsPerPage = pageSize;
    this.pagingConfig.currentPage = 1;
    this.filter = {
      ...this.filter,
      skip: 0,
      limit: this.pagingConfig.itemsPerPage,
    };
    if (!this.localSearchValue) {
      this.getList();
    } else {
      this.pagingConfig.totalItems = this.records.length;
    }
  }

  onSearch(value: string) {
    this.getList();
  }

  onCreateView(view: any) {
    const views = this.views;
    view.cid = 'cid-' + new Date().getTime();
    this.views.push(view);
    localStorage.setItem('views', JSON.stringify(views));
  }

  onViewsChange(views: any[]) {
    this.views = views;
    localStorage.setItem('views', JSON.stringify(views));
  }

  onFilter($event: { searchMeta: Array<any>; filters: Array<any>; adv_filters: Array<any>; is_refresh: boolean }) {
    if (!$event.is_refresh) {
      this.pagingConfig.currentPage = 1;
      this.pagingConfig.totalItems = 0;
      this.filter.skip = 0;
    }

    $event.filters.forEach((filter: any) => {
      if (filter.key === 'agent') {
        this.selectedAgentId = filter.value || '';
      } else if (filter.key === 'start_end') {
        this.fromDate = moment(filter.value[0]).toISOString();
        this.toDate = moment(filter.value[1]).toISOString();
      } else if (filter.key === 'call_sid') {
        this.call_sid = filter.value || '';
      }
    });
    this.adv_filters = $event.adv_filters;
    this.search_meta = $event.searchMeta;
    this.getList();
  }

  // need to be create a pipe
  formatDateLocal(num: number) {
    return formatDate(num);
  }
  // Method to toggle the dropdown visibility
  toggleDropdown(ctx: any): void {
    if (ctx.row.show) {
      ctx.row.show = !ctx.row.show;
    } else {
      this.hideAllDropdowns();
      ctx.row.show = !ctx.row.show;
    }
  }

  // Optionally, a method to hide all dropdowns
  hideAllDropdowns(): void {
    this.records.forEach((key) => {
      key.show = false;
    });
  }
  onClickOutSide() {
    console.log(new Date().toLocaleString() + '  ➤  ooutside');
  }
  public isIbexDialer() {
    const providerKey = this.authService.authData?.ClientInfo?.Provider?.TelephoneProvider?.toLowerCase();
    return providerKey === 'ibex' ? true : false;
  }

  public onGridSettingSave($event: any): void {
    this.navService.setGridSettings(`grid_${this.reportType}`, $event);
  }

  private getGridSetting(): void {
    this.navService.getGridSettings(`grid_${this.reportType}`).subscribe((gridSettings: any) => {
      if (gridSettings.length > 0) {
        const orderedColumns = gridSettings
          .map((setting: any) => {
            const column = this.columns.find(
              (col) => col.key === setting.key
            );
            if (column) {
              return {
                ...column,
                frozen: setting.frozen,
                viewable: setting.viewable,
              };
            }

            return null;
          })
          .filter(Boolean);
        this.columns = orderedColumns;
        const startEndColumn = this.configColumns.find(col => col?.key === 'start_end');

        if (startEndColumn) {
          startEndColumn.options = DateOptions;

          if (!this.columns.some(col => col?.key === 'start_end')) {
            this.columns.push(startEndColumn);
          }
        }
      }
    });
  }
}
